import Point = createjs.Point;

export class CameraTargetPoint {

    public targetPoint: Point;
    public isRelative: boolean;

    public targetFollowSpeed: number = 500;
    public targetFollowAcceleration: number = 100;
    public targetFollowMaxSpeed: number = 1000;

    public centerPoint: Point;

    constructor(targetPoint: Point, centerPoint: Point, targetFollowSpeed: number, targetFollowAcceleration: number = 0, targetFollowMaxSpeed: number = 0, isRelative: boolean = true) {
        this.targetPoint = targetPoint;
        this.centerPoint = centerPoint;
        this.targetFollowSpeed = targetFollowSpeed;
        this.targetFollowAcceleration = targetFollowAcceleration;
        this.targetFollowMaxSpeed = targetFollowMaxSpeed;
        if (targetFollowMaxSpeed == 0) {
            this.targetFollowMaxSpeed = targetFollowSpeed;
        }
        this.isRelative = isRelative;
    }

    public getCorrectedTargetPoint(zoom: number): Point {
        let correctedTargetPoint: Point;
        if (this.isRelative) {
            correctedTargetPoint = new Point(this.centerPoint.x - (this.targetPoint.x * zoom), this.centerPoint.y - (this.targetPoint.y * zoom));
        }
        else {
            correctedTargetPoint = this.targetPoint.clone();
        }
        return correctedTargetPoint;
    }
}
